import { OfficialProblemCategory } from '@/domain/entities/problem/officialProblemCategory'
import { ProblemRepository } from '@/domain/repositories/problem/ProblemRepository'

export class GetOfficialProblemCategoryUseCase {
  constructor(private repository: ProblemRepository) {}

  async getOfficialProblemCategory(): Promise<OfficialProblemCategory[]> {
    try {
      const data = await this.repository.getOfficialProblemCategory()
      return data
    } catch (error) {
      console.error(
        `Error in GetOfficialProblemCategoryUseCase: ${error instanceof Error ? error.message : String(error)}`
      )
      throw error
    }
  }
}
